export default __webpack_public_path__ + "static/media/post-img.5af2d129.jpg";